export const snakeCase = (str: string): string => {
  return str
    .replace(/\W+/g, ' ') // Replace non-word characters with space
    .trim() // Trim leading and trailing spaces
    .split(/ |\B(?=[A-Z])/) // Split at spaces or before uppercase letters
    .map((word) => word.toLowerCase()) // Convert all words to lowercase
    .join('_'); // Join using underscore
};
